export default function() {
  return new SharedWorker(__webpack_public_path__ + "static/js/admin-worker.shared-worker.worker.js");
}
